module.exports = __webpack_public_path__ + "static/media/028.8331d41f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/028.jpg
// module id = 535
// module chunks = 0